// extracted by mini-css-extract-plugin
export default {"wrap":"button_wrap__TWbeU","fit":"button_fit__OtyVv","disabled":"button_disabled__JzEFf"};